export default "__VITE_ASSET__CMz1cFV5__"